module.exports = __webpack_public_path__ + "static/media/zappertak-3.f7902ab5.jpg";